import { reactionApi, ReactionApi } from '@petconsole/pure-fe-api';
import { EntityType } from '@petconsole/pure-shared';
import { appThunk } from '../../store/appThunk';
import { payloadCreatorFetchReaction } from '../payloadCreators';

const fetchReactionThunk = (sliceName: string, entityType: EntityType, idName: string, api: ReactionApi = reactionApi) =>
  appThunk(`${sliceName}/fetch${entityType}Reaction`, payloadCreatorFetchReaction(idName, entityType, api));

export default fetchReactionThunk;
